/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { Logo } from '../../../components/shared';

const SignupLayout = ({
  withBack,
  children,
  title,
  renderFooter,
  onPrevClick,
  withLogoOnMobile,
  withShadowOnMobile,
  centerTitleOnMobile,
  customPadding,
  customClassName,
  rightTitle,
  withCloseBtn,
  onClose,
  withCloseBtnOnMobile,
}) => {
  const history = useHistory();

  return (
    <>
      {/* browser layout */}
      <div className="container vh-100 d-none d-md-flex flex-column align-items-center">
        <div className="row" style={{ paddingTop: '4rem', paddingBottom: '2.464rem' }}>
          <Logo />
        </div>
        <div className="row mb-5 w-100">
          <div
            className={`onboarding-card position-relative shadow mx-auto bg-lighter ${customClassName}`}
            style={{
              padding: customPadding ? '' : '4rem',
              ...(customPadding ? { ...customPadding } : {}),
            }}>
            <div className="card-body flex-grow-0 p-0">
              {withCloseBtn && (
                <div className="position-absolute" style={{ top: '2%', right: '2%' }}>
                  <span
                    style={{ zIndex: '1001' }}
                    className="me-2"
                    role="button"
                    tabIndex="0"
                    onKeyPress={onClose}
                    onClick={onClose}>
                    <img src="./assets/images/close.svg" alt="close" />
                  </span>
                </div>
              )}
              {title && withBack && (
                <div className="d-flex flex-row justify-content-between align-items-center">
                  <span
                    className="flex-row align-items-center d-flex hover-children"
                    onClick={onPrevClick}
                    role="button"
                    tabIndex="0"
                    onKeyPress={onPrevClick}>
                    <div className="pt-1">
                      <i
                        className="icon icon-arrow-back-navigation text-f4 me-2"
                        role="button"
                        aria-label="Back"
                      />
                    </div>
                    <span className="m-0 font-weight-bold">
                      <span className="m-0">
                        <b>{title}</b>
                      </span>
                    </span>
                  </span>
                  {rightTitle && rightTitle()}
                </div>
              )}
              {title && !withBack && (
                <div className="d-flex flex-row justify-content-between align-items">
                  <span className="flex-row align-items-center d-flex">
                    <span className="m-0 font-weight-bold">
                      <span className="m-0">
                        <b>{title}</b>
                      </span>
                    </span>
                  </span>
                  {rightTitle && rightTitle()}
                </div>
              )}
              {children}
            </div>
            {renderFooter && <div className="card-footer p-0">{renderFooter()}</div>}
          </div>
        </div>
      </div>

      {/* mobile layout */}
      <div className="container vh-100 d-flex d-md-none flex-column align-items-center justify-content-between me-0">
        {withCloseBtnOnMobile && (
          <div className="d-flex flex-row align-items-end justify-content-end mb-4 mt-3 w-100">
            <span
              style={{ zIndex: '1001' }}
              className="me-2"
              role="button"
              tabIndex="0"
              onKeyPress={() => history.push(`/promo`)}
              onClick={() => history.push(`/promo`)}>
              <img src="./assets/images/close.svg" alt="close" />
            </span>
          </div>
        )}
        {withLogoOnMobile && (
          <div className="row pt-5 flex-fill">
            <Logo style={{ height: '20vh' }} />
          </div>
        )}
        <div
          className={`row w-100 flex-fill position-fixed m-0 p-0 ${
            withLogoOnMobile ? 'bottom-0' : 'top-0'
          }`}>
          <div
            className={`mx-auto px-4 pb-4 ${withShadowOnMobile ? ' bg-lighter shadow ' : ''} ${
              withLogoOnMobile ? 'rounded-top' : 'rounded-bottom pb-0'
            }`}
            style={{ paddingTop: '1.5rem' }}>
            <div className="card-body p-0">
              {title && (
                <div className="d-flex flex-row justify-content-between align-items-center">
                  <div className="flex-row d-flex flex-fill">
                    <span
                      onClick={withBack ? onPrevClick : null}
                      role="button"
                      tabIndex="0"
                      onKeyPress={withBack ? onPrevClick : null}>
                      {withBack && (
                        <div className="pt-1">
                          <i
                            className="icon icon-arrow-back-navigation text-f4 me-2"
                            role="button"
                            aria-label="Back"
                          />
                        </div>
                      )}
                    </span>
                    <span
                      className={`m-0 font-weight-bold ${
                        centerTitleOnMobile ? 'd-flex justify-content-center flex-grow-1' : ''
                      }`}
                      style={{ lineHeight: '2rem' }}>
                      <span className="m-0">
                        <b>{title}</b>
                      </span>
                    </span>
                  </div>
                  {rightTitle && rightTitle()}
                </div>
              )}
              {children}
            </div>
            {withLogoOnMobile && renderFooter && (
              <div className="card-footer p-0">{renderFooter()}</div>
            )}
          </div>
          {!withLogoOnMobile && renderFooter && (
            <div className="card-footer" style={{ position: 'fixed', bottom: '1rem' }}>
              {renderFooter()}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default SignupLayout;

SignupLayout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  withBack: PropTypes.bool,
  renderFooter: PropTypes.func,
  title: PropTypes.string,
  onPrevClick: PropTypes.func,
  withLogoOnMobile: PropTypes.bool,
  withShadowOnMobile: PropTypes.bool,
  centerTitleOnMobile: PropTypes.bool,
  customPadding: PropTypes.object,
  customClassName: PropTypes.string,
  rightTitle: PropTypes.func,
  withCloseBtn: PropTypes.bool,
  onClose: PropTypes.func,
  withCloseBtnOnMobile: PropTypes.bool,
};

SignupLayout.defaultProps = {
  withBack: null,
  onPrevClick: null,
  title: null,
  renderFooter: null,
  withLogoOnMobile: true,
  withShadowOnMobile: true,
  centerTitleOnMobile: false,
  customPadding: null,
  customClassName: null,
  rightTitle: null,
  withCloseBtn: false,
  onClose: null,
  withCloseBtnOnMobile: true,
};
